import {
  TipoTenantEnum,
  TipoEstruturaMoradiaEnum,
} from "core/resources/enums/tenant";

export interface User {
  id: string;
  pessoaId: string;
  nome: string | null;
  email: string | null;
  imagemUrl: string | null;
  tenants: TenantMeResponse[];
  permissoes: string[];
}

export interface UserProfile {
  nome: string;
  documento: string;
  email: string;
  imagemUrl: string | null;
  telefone: string | null;
  dataNascimento: string | null;
  sexo: TipoSexo | null;
}

export interface UserEndereco {
  cep: string;
  logradouro: string;
  complemento: string;
  numero: string;
  bairro: string;
  estadoId: string;
  cidadeId: string;
}

export interface TenantMeResponse {
  id: string;
  nome: string;
  imagemUrl: string;
  tipoTenant: string;
  tipoTenantId: TipoTenantEnum;
  tenantPai: { id: string; nome: string } | null;
  tipoEstruturaMoradia: TipoEstruturaMoradiaEnum;
  finishOnboardingDate: string | null;
  pessoaId: string;
}

export interface TenantMePaiResponse extends TenantMeResponse {
  items: TenantMeResponse[];
}

// export interface Contact {
//   usuarioId?: string | null;
//   conteudo: string;
//   id: string;
//   tipoContatoId: string;
//   tipoContato: {
//     id: string;
//     nome: string;
//   };
// }

export enum TipoContatoEnum {
  Telefone = "74089AE4-E071-4C0D-91EE-7D31B7BA2BB6",
  Celular = "2A3B769B-FE39-4F53-96A8-43A5F9141D39",
  Email = "97393EF8-E4B8-4DDA-972E-02F7AA0E0916",
  SMS = "C7FA3E99-FDE4-4DEA-93BE-525135609398",
  Outros = "AD86F0E0-A512-4D09-866D-13002EB3CDD0",
  AplicativoMensagem = "E342BC57-B399-4A39-A197-255E56C59CC2",
  Carta = "34CCDBEB-06E7-429F-801B-8666F921A53B",
}

export enum MeioComunicacaotipo {
  SMS = "sms",
  Telefone = "telefone",
  Email = "email",
  Outros = "outros",
}

export enum TipoSexo {
  Masculino = "m",
  Feminino = "f",
  Outro = "o",
}
